import { render, staticRenderFns } from "./middle.vue?vue&type=template&id=4abeaf3e&"
import script from "./middle.vue?vue&type=script&lang=js&"
export * from "./middle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports